import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { UserCircleIcon } from "@heroicons/react/20/solid";
import { Input } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import loginImage from "../Images/login.png";
import logo from "../Images/Logos/PNG.png";
const Register = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "student",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const toggleForm = () => {
    setIsLogin(!isLogin);
    setSuccessMessage("");
    setErrorMessage("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(
        `http://localhost:5000/api/${isLogin ? "login" : "register"}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      if (data.token) {
        setSuccessMessage(data.message);
        setErrorMessage("");
        if (isLogin) {
          navigate("/blog/admin/view");
        }
        localStorage.setItem("token", data.token);
      } else {
        setErrorMessage(data.message);
        setSuccessMessage("");
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
      setSuccessMessage("");
    }
    setLoading(false);
  };

  return (
    <div className="h-screen px-10 bg-gradient-to-r from-teal-400 via-teal-500 to-teal-700 absolute top-0 bottom-0 left-0 right-0">
      <a
        className="flex items-center text-teal-800 no-underline hover:no-underline font-bold text-2xl lg:text-4xl md:mt-10 mt-6"
        href="#"
      >
        <img
          src={logo}
          className="lg:w-12 lg:h-12 md:w-10 md:h-10 w-8 h-8 block mr-2"
        />
        Solvexa
        <span className="bg-clip-text text-transparent bg-gradient-to-r text-white p-1">
          Marketing
        </span>
      </a>
      <div className="flex lg:mt-14 md:mt-10 mt-6 justify-center items-center">
        <div className="bg-white shadow-lg shadow-teal-300 rounded-lg flex p-8 max-w-4xl w-full mt-14 md:mt-8 lg:mt-8">
          <div className="w-full md:w-1/2 p-4">
            <p className="text-2xl font-bold text-gray-800 mb-6">
              {isLogin ? "Log In" : "Sign Up"}
            </p>
            <form className="space-y-4 mt-10 md:mt-15" onSubmit={handleSubmit}>
              {!isLogin && (
                <div className="relative">
                  <Input
                    name="name"
                    placeholder="Name"
                    type="text"
                    className="w-full px-3 py-2 text-black border-b bg-white border-gray-300 pr-10 rounded-none"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  <UserCircleIcon className="absolute right-3 top-[20px] transform -translate-y-1/2 w-6 text-teal-600" />
                </div>
              )}

              <div className="relative">
                <Input
                  name="email"
                  type="email"
                  placeholder="Email"
                  className="w-full px-3 py-2 text-black border-b border-gray-300 bg-white pr-10 rounded-none"
                  value={formData.email}
                  onChange={handleChange}
                />
                <svg
                  className="absolute right-3 top-[20px] transform -translate-y-1/2 w-5 text-teal-600"
                  width="30"
                  height="35"
                  viewBox="0 0 30 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 6.36833H25V23.06H6.4625L5 24.6874V6.36833ZM5 3.58639C3.625 3.58639 2.5125 4.83826 2.5125 6.36833L2.5 31.4058L7.5 25.842H25C26.375 25.842 27.5 24.5901 27.5 23.06V6.36833C27.5 4.83826 26.375 3.58639 25 3.58639H5ZM7.5 17.4961H22.5V20.2781H7.5V17.4961ZM7.5 13.3232H22.5V16.1051H7.5V13.3232ZM7.5 9.15028H22.5V11.9322H7.5V9.15028Z"
                    fill="#039682"
                  />
                </svg>
              </div>

              <div className="relative">
                <Input.Password
                  name="password"
                  placeholder="Password"
                  className="w-full px-3 py-2 text-black border-b border-gray-300 bg-white rounded-none"
                  value={formData.password}
                  onChange={handleChange}
                  iconRender={(visible) =>
                    visible ? (
                      <EyeTwoTone className="icon" />
                    ) : (
                      <EyeInvisibleOutlined className="icon" />
                    )
                  }
                  visibilityToggle={{
                    visible: passwordVisible,
                    onVisibleChange: setPasswordVisible,
                  }}
                />
              </div>

              {successMessage && (
                <div
                  role="alert"
                  className="alert alert-success bg-green-400 text-white p-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 shrink-0 stroke-current"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span>{successMessage}</span>
                </div>
              )}
              {errorMessage && (
                <div
                  role="alert"
                  className="alert alert-error bg-teal-400 text-white p-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6 shrink-0 stroke-current"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span>{errorMessage}</span>
                </div>
              )}

              <div className="flex justify-center">
                <button
                  type="submit"
                  className={`${
                    loading && "btn-disabled"
                  } mt-10 justify-center block btn border-none w-[150px] bg-gradient-to-r from-teal-700 via-teal-500 to-teal-400 text-white font-semibold py-2 px-2 md:py-2 md:px-2 lg:py-3 lg:px-2 rounded-lg hover:from-teal-700 hover:via-teal-600 hover:to-teal-500 hover:scale-105`}
                >
                  {isLogin ? "Login" : "Sign Up"}
                </button>
              </div>
            </form>
          </div>
          <div className="hidden md:block w-1/2 p-4">
            <img
              src={loginImage}
              alt="Login Illustration"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
